import React from 'react';
import { useNavigate } from 'react-router-dom';

const EventCard = ({ cardType, customKey, imageSrc, title, description }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        cardType === 'Past' && navigate(`/gallery/#section${customKey}`);
      }}
      className={`w-[343px] pt-[10px] pb-[20px] px-[15px] rounded-[10px] bg-gradient-to-b from-[#FB823C] to-[#C2320C] 
      ${cardType === 'Past' && 'hover:cursor-pointer'}`}
    >
      <img
        loading="lazy"
        src={imageSrc}
        alt={title}
        className="object-cover w-full rounded-xl aspect-[1.52]"
      />
      <div className="mt-[10px] text-white">
        <p className="font-abhaya text-[28px] text-left">{title}</p>
        {/* Use dangerouslySetInnerHTML to render bold dates */}
        <p
          className="mt-4 font-afacad text-[16px] text-left"
          dangerouslySetInnerHTML={{ __html: description }}
        ></p>
      </div>
    </div>
  );
};

export default EventCard;
